module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../applications/PDCDashboard/frontend/src/node_modules/source-map-loader/dist/cjs.js!./ResourceBrowser.js"));
	});
}